import { render, staticRenderFns } from "./ReactionTextButton.vue?vue&type=template&id=eff66176&scoped=true&lang=pug"
import script from "./ReactionTextButton.vue?vue&type=script&lang=ts"
export * from "./ReactionTextButton.vue?vue&type=script&lang=ts"
import style0 from "./ReactionTextButton.vue?vue&type=style&index=0&id=eff66176&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff66176",
  null
  
)

export default component.exports